<script setup lang="ts">
import { PlaybookRiskLevel } from '@/api';
import type { PlaybookEvaluationOption } from '@/services/playbooks/playbookRunDisplay';
import GaiaRiskPill from '@/components/design/base/GaiaRiskPill.vue';
import GaiaText from '@/components/design/base/GaiaText.vue';
import { playbookRiskLevelMap } from '@/components/design/statusMaps';

defineProps<{
  matchedOptions: PlaybookEvaluationOption[];
}>();
</script>

<template>
  <n-flex vertical :size="10">
    <n-flex
      v-for="option in matchedOptions"
      :key="option.uid"
      vertical
      :size="4"
      align="flex-start"
    >
      <gaia-risk-pill
        :level="playbookRiskLevelMap[option.risk_level ?? PlaybookRiskLevel.NONE].level"
      >
        {{ option.name }}
      </gaia-risk-pill>
      <gaia-text v-if="option.definition" size="row" tone="tertiary">
        {{ option.definition }}
      </gaia-text>
    </n-flex>
    <gaia-text v-if="matchedOptions.length === 0" tone="subtle">No option matched.</gaia-text>
  </n-flex>
</template>
